<template>
  <Dialog :open="isOpen" @update:open="$emit('close')">
    <DialogContent
      class="sm:max-w-[500px] p-0 overflow-hidden rounded-[24px] border-none shadow-2xl"
    >
      <div class="bg-card w-full">
        <!-- Header -->
        <div class="p-6 border-b border-border bg-muted/5">
          <div class="flex items-center gap-4 mb-4">
            <div
              class="w-12 h-12 rounded-full bg-primary/10 text-primary font-bold flex items-center justify-center text-lg"
            >
              {{ (request.user_name || "U").charAt(0) }}
            </div>
            <div>
              <h3 class="text-xl font-bold text-foreground">
                {{ request.user_name }}
              </h3>
              <p class="text-sm text-muted-foreground">
                {{ request.topic || "Hub Request" }}
              </p>
            </div>
          </div>

          <div class="flex flex-wrap gap-4 mt-2">
            <div
              class="flex items-center gap-2 text-sm text-muted-foreground bg-muted/30 px-3 py-1.5 rounded-full"
            >
              <Calendar class="w-4 h-4 text-primary" />
              {{ formatDate(request.booking_date) }}
            </div>
            <div
              class="flex items-center gap-2 text-sm text-muted-foreground bg-muted/30 px-3 py-1.5 rounded-full"
            >
              <Clock class="w-4 h-4 text-primary" />
              {{ formatTime(request.booking_date) }}
            </div>
          </div>
        </div>

        <!-- Body -->
        <div class="p-6 space-y-6">
          <div class="space-y-2">
            <h4
              class="text-[12px] font-bold text-muted-foreground uppercase tracking-widest"
            >
              Request Details
            </h4>
            <div class="p-4 bg-muted/20 border border-border rounded-xl">
              <p class="text-sm text-foreground/80 leading-relaxed italic">
                "{{ request.details || "No additional details provided." }}"
              </p>
            </div>
          </div>

          <div class="grid grid-cols-2 gap-4">
            <div class="p-4 bg-muted/10 rounded-xl border border-border/50">
              <p
                class="text-[11px] font-bold text-muted-foreground uppercase mb-1"
              >
                Status
              </p>
              <p class="text-sm font-semibold text-foreground italic">
                Pending Review
              </p>
            </div>
            <div class="p-4 bg-muted/10 rounded-xl border border-border/50">
              <p
                class="text-[11px] font-bold text-muted-foreground uppercase mb-1"
              >
                Priority
              </p>
              <p class="text-sm font-semibold text-foreground">Standard</p>
            </div>
          </div>
        </div>

        <!-- Footer Actions -->
        <div
          class="p-6 bg-muted/5 border-t border-border flex items-center gap-3"
        >
          <button
            @click="$emit('decline', request)"
            class="flex-1 px-4 py-3 border border-border rounded-full text-sm font-bold text-foreground hover:bg-muted transition-colors"
          >
            Decline Request
          </button>
          <button
            @click="$emit('approve', request)"
            class="flex-1 px-4 py-3 bg-primary text-primary-foreground rounded-full text-sm font-bold hover:opacity-90 transition-opacity"
          >
            Approve Request
          </button>
        </div>
      </div>
    </DialogContent>
  </Dialog>
</template>

<script setup>
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Calendar, Clock } from "lucide-vue-next";
import dayjs from "dayjs";

defineProps({
  isOpen: Boolean,
  request: {
    type: Object,
    required: true,
  },
});

defineEmits(["close", "approve", "decline"]);

const formatDate = (date) => {
  return dayjs(date).format("MMM DD, YYYY");
};

const formatTime = (date) => {
  return dayjs(date).format("h:mm A");
};
</script>
